import { ShareChannel } from '@tencent/vb-app-bridge';
/**
 * 默认的链接分享渠道列表
 */
export var DefaultShareLinkChannelList = [
    ShareChannel.FACEBOOK,
    ShareChannel.WHATSAPP,
    ShareChannel.WECHAT_MESSAGE,
    ShareChannel.WECHAT_MOMENT,
    ShareChannel.MESSENGER,
    ShareChannel.COPYLINK,
    ShareChannel.MORE,
];
/**
 * 默认的链接和图片分享渠道列表
 */
export var DefaultShareLinkAndImageChannelList = [
    ShareChannel.FACEBOOK,
    ShareChannel.WHATSAPP,
    ShareChannel.WECHAT_MESSAGE,
    ShareChannel.WECHAT_MOMENT,
    ShareChannel.MESSENGER,
    ShareChannel.COPYLINK,
    ShareChannel.SAVE_PICTURE,
    ShareChannel.MORE,
];
/**
 * 默认的图片分享渠道列表
 */
export var DefaultImageLinkChannelList = [
    ShareChannel.FACEBOOK,
    ShareChannel.WHATSAPP,
    ShareChannel.WECHAT_MESSAGE,
    ShareChannel.WECHAT_MOMENT,
    ShareChannel.MESSENGER,
    ShareChannel.SAVE_PICTURE,
    ShareChannel.MORE,
];
/**
 * 默认异常提示文案
 */
export var DefaultErrorMessage = '系统繁忙，请稍后重试';
/**
 * 没有系统图片权限异常提示
 */
export var NoPicPermissionErrorMessage = '该应用没有保存图片的权限';
